import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { Puma_Title } from '../../../../../utils/ES/Modals/SpotsModals';

const ModalRayados = () => {
  return (
    <>
      <ModalVideo
        id="spot-rayados"
        dataText={Puma_Title}
        videoSrc="https://player.vimeo.com/video/381595104?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
        videoTitle="KUTER_STUDIO_RAYADOS"
      />
    </>
  );
};

export default ModalRayados;
